import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiDroplet, FiCamera, FiHome, FiTrendingUp, FiSettings, FiActivity } = FiIcons;

const Services = () => {
  const services = [
    {
      icon: FiDroplet,
      title: 'Blocked Sinks',
      description: 'Quick and efficient solutions for kitchen, bathroom, or utility room sink blockages. We’ll get it flowing again.',
      color: 'blue'
    },
    {
      icon: FiActivity,
      title: 'Showers & Baths',
      description: 'From trays to tubs, we unblock all types of showers and baths. Fast service to get you back to normal.',
      color: 'blue'
    },
    {
      icon: FiHome,
      title: 'Shared Drains',
      description: 'Clearing and jetting for shared drainage in flats, apartments, or streets — keeping everything running smoothly.',
      color: 'blue'
    },
    {
      icon: FiTrendingUp,
      title: 'Drain Jetting',
      description: 'High-pressure water jetting to tackle the toughest blockages — fast, powerful, and thorough.',
      color: 'blue'
    },
    {
      icon: FiCamera,
      title: 'CCTV Inspection',
      description: 'Affordable CCTV drain surveys to pinpoint problems fast — ideal for persistent issues or property purchases.',
      color: 'blue'
    },
    {
      icon: FiSettings,
      title: 'Drain Repairs',
      description: 'Comprehensive repair solutions for damaged or collapsed drains. We restore your system to full health.',
      color: 'blue'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-blue-600 font-bold uppercase tracking-widest mb-4">What We Do</h2>
          <h3 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6">
            Trusted & Efficient Drainage Solutions
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We sort drainage problems quickly. No waiting around, just reliable service from local pros in Manchester.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white p-8 rounded-3xl shadow-sm hover:shadow-xl transition-all border border-gray-100 group hover:-translate-y-2"
            >
              <div className="bg-blue-50 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
                <SafeIcon icon={service.icon} className="text-blue-600 text-3xl group-hover:text-white transition-colors" />
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h4>
              <p className="text-gray-600 text-lg leading-relaxed">
                {service.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;